'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Renders a table displaying information in two columns.
 */
var DualColumnTableComponent = function DualColumnTableComponent(_ref) {
  var rows = _ref.rows,
      keys = _ref.keys,
      rest = _objectWithoutProperties(_ref, ['rows', 'keys']);

  return _react2.default.createElement(
    _reactBootstrap.Table,
    _extends({}, rest, { className: 'ingle-form-dual-column-table' }),
    _react2.default.createElement(
      'tbody',
      null,
      rows.map(function (element, index) {
        return _react2.default.createElement(
          'tr',
          { key: index },
          _react2.default.createElement(
            'th',
            null,
            element[keys.th]
          ),
          _react2.default.createElement(
            'td',
            null,
            element[keys.td]
          )
        );
      })
    )
  );
};

DualColumnTableComponent.propTypes = {
  rows: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.objectOf(_react2.default.PropTypes.string)).isRequired,
  keys: _react2.default.PropTypes.shape({
    th: _react2.default.PropTypes.string.isRequired,
    td: _react2.default.PropTypes.string.isRequired
  })
};

exports.default = DualColumnTableComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/DualColumnTableComponent.jsx
// module id = 802
// module chunks = 0